import * as React from 'react';
import { createHashRouter, RouterProvider, Navigate } from 'react-router-dom';
import GuardRoute from './components/guardRoute';
import { AuthContextProvider } from './context/auth';
import { ThemeContextProvider } from './context/theme';
import { GlobalsContextProvider } from './context/globals';
import { LoadingModalContextProvider } from './components/modal/loading';
import { AlertModalContextProvider } from './components/modal/alert';
import { SnackbarProvider } from 'notistack';

import Login from './pages/login';
import Dashboard from './pages/dashboard';
import ReestablecerClave from './pages/reestablecer-clave';
import Usuario from './pages/usuario';
import EditarUsuario from './pages/usuario/editar';
import Practica from './pages/practica';
import EditarPractica from './pages/practica/editar';
import Establecimiento from './pages/establecimiento';
import EditarEstablecimiento from './pages/establecimiento/editar';
import Paciente from './pages/paciente';
import EditarPaciente from './pages/paciente/editar';
import VerPaciente from './pages/paciente/ver';
import OrdenPractica from './pages/orden-practica';
import NuevaOrdenPractica from './pages/orden-practica/nueva';
import DetalleOrdenPractica from './pages/orden-practica/detalle';
import Auditoria from './pages/auditoria';

const router = createHashRouter([
	{ path: "/login", element: <GuardRoute type="public" path="/login" component={<Login />} /> },
	{ path: "/login/:token/:window", element: <GuardRoute type="public" path="/login/:token/:window" component={<Login />} /> },
	{ path: "/reestablecer-clave/:token", element: <GuardRoute type="public" path="/reestablecer-clave/:token" component={<ReestablecerClave />} /> },
	{ path: "/dashboard", element: <GuardRoute type="private" path="/dashboard" component={<Dashboard />} /> },
	{ path: "/usuario/nuevo", element: <GuardRoute type="private" path="/usuario/nuevo" component={<EditarUsuario />} /> },
	{ path: "/usuario/editar", element: <GuardRoute type="private" path="/usuario/editar" component={<EditarUsuario />} /> },
	{ path: "/usuario", element: <GuardRoute type="private" path="/usuario" component={<Usuario />} /> },
	{ path: "/practica/nuevo", element: <GuardRoute type="private" path="/practica/nuevo" component={<EditarPractica />} /> },
	{ path: "/practica/editar", element: <GuardRoute type="private" path="/practica/editar" component={<EditarPractica />} /> },
	{ path: "/practica", element: <GuardRoute type="private" path="/practica" component={<Practica />} /> },
	{ path: "/establecimiento/nuevo", element: <GuardRoute type="private" path="/establecimiento/nuevo" component={<EditarEstablecimiento />} /> },
	{ path: "/establecimiento/editar", element: <GuardRoute type="private" path="/establecimiento/editar" component={<EditarEstablecimiento />} /> },
	{ path: "/establecimiento", element: <GuardRoute type="private" path="/establecimiento" component={<Establecimiento />} /> },
	{ path: "/paciente/nuevo", element: <GuardRoute type="private" path="/paciente/nuevo" component={<EditarPaciente />} /> },
	{ path: "/paciente/editar", element: <GuardRoute type="private" path="/paciente/editar" component={<EditarPaciente />} /> },
	{ path: "/paciente/ver", element: <GuardRoute type="private" path="/paciente/ver" component={<VerPaciente />} /> },
	{ path: "/paciente", element: <GuardRoute type="private" path="/paciente" component={<Paciente />} /> },
	{ path: "/orden-practica/nueva", element: <GuardRoute type="private" path="/orden-practica/nueva" component={<NuevaOrdenPractica />} /> },
	{ path: "/orden-practica/:id", element: <GuardRoute type="private" path="/orden-practica/:id" component={<DetalleOrdenPractica />} /> },
	{ path: "/orden-practica", element: <GuardRoute type="private" path="/orden-practica" component={<OrdenPractica />} /> },
	{ path: "/auditoria", element: <GuardRoute type="private" path="/auditoria" component={<Auditoria />} /> },
	{ path: "/", element: <Navigate to="/login" replace /> },
]);

export default function AppRoot() {
	return (
		<AuthContextProvider>
			<GlobalsContextProvider>
				<ThemeContextProvider>
					<SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: "center", vertical: "bottom" }} autoHideDuration={6000}>
						<LoadingModalContextProvider>
							<AlertModalContextProvider>
								<InnerApp />
							</AlertModalContextProvider>
						</LoadingModalContextProvider>
					</SnackbarProvider>
				</ThemeContextProvider>
			</GlobalsContextProvider>
		</AuthContextProvider>
	);
}

function InnerApp() {
	React.useEffect(() => {
		const el = document.getElementById('initial-splash');
		const hide = () => {
			if (el?.parentNode) {
				try {
					el.parentNode.removeChild(el);
				} catch (_) {}
			}
		};
		requestAnimationFrame(() => requestAnimationFrame(hide));
	}, []);
	return <RouterProvider router={router} />;
}
